import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'

export function ScrollToTop() {
  const location = useLocation()
  const prevPathnameRef = useRef(location.pathname)

  useEffect(() => {
    // Only scroll to top if the pathname has changed (new page navigation)
    if (prevPathnameRef.current !== location.pathname) {
      if (typeof window !== 'undefined') {
        window.scrollTo({ top: 0, left: 0, behavior: 'auto' })
      }
      prevPathnameRef.current = location.pathname
    }
  }, [location.pathname])

  return null
}
